module.exports = __webpack_public_path__ + "img/triangle.be4644d4.svg";